import { statAsync } from "../../../util/fs";
import lazyRequire from "../../../util/lazyRequire";
import { log } from "../../../util/log";
import path from "path";
const exeVersion = lazyRequire(() => require("exe-version"));
export async function testExtProvider(game, discovery) {
    return Promise.resolve(game.getGameVersion !== undefined);
}
export async function getExtGameVersion(game, discovery) {
    try {
        const version = await game.getGameVersion(discovery.path, discovery.executable || game.executable());
        if (typeof version !== "string") {
            return Promise.reject(new Error("getGameVersion functor returned an invalid type"));
        }
        return version;
    }
    catch (err) {
        return Promise.reject(err);
    }
}
export async function testExecProvider(game, discovery) {
    const exeName = discovery.executable || game.executable();
    if (discovery?.path === undefined || exeName === undefined) {
        // can be caused by a broken extension
        return Promise.resolve(false);
    }
    const exePath = path.join(discovery.path, exeName);
    try {
        await statAsync(exePath);
        const version = exeVersion.default(exePath);
        return version === "0.0.0" ? Promise.resolve(false) : Promise.resolve(true);
    }
    catch (err) {
        log("error", "unable to test executable version fields", err);
        return Promise.resolve(false);
    }
}
export async function getExecGameVersion(game, discovery) {
    const exePath = path.join(discovery.path, discovery.executable || game.executable());
    try {
        const version = exeVersion.default(exePath);
        return Promise.resolve(version);
    }
    catch (err) {
        return Promise.resolve("0.0.0");
    }
}
